// extracted by mini-css-extract-plugin
export default {"waitingPage":"Q0iHWe","waitingCard":"wRqZTW","waitingTitle":"eRyWXF","waitingText":"XHQ0hJ"};